import PropTypes from "prop-types";

import { FlexContainers, WrapperContainer } from "../../components";
import SelectedItem from "./SelectedItem";
import { SelectedItemsListWrapper } from "./styled";

const SelectedItemsList = ({ items, onDelete, checkIsOptionDisabled, children }) => {
  return items ? (
    <SelectedItemsListWrapper width={"100%"}>
      <WrapperContainer
        as="ul"
        Container={FlexContainers.FlexRowStart}
        gap={6}
        wrap={"wrap"}
        width="100%">
        {items.map((option) =>
          option.id ? (
            <SelectedItem
              key={option.id}
              value={option.value}
              disabled={checkIsOptionDisabled ? checkIsOptionDisabled(option.id) : false}
              onDelete={(event) => {
                event.stopPropagation();
                onDelete(option.id);
              }}
            />
          ) : null
        )}
        {children}
      </WrapperContainer>
    </SelectedItemsListWrapper>
  ) : null;
};

SelectedItemsList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  onDelete: PropTypes.func.isRequired,
  checkIsOptionDisabled: PropTypes.func,
  viewOnlyOptionIds: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  ),
  children: PropTypes.node
};

export default SelectedItemsList;
